import React, { useEffect, useState } from "react";
import { Button, Label } from "abs-ui-components";
import { MDBCol, MDBRow } from "mdbreact";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs from "dayjs";
import { Controller, useForm } from "react-hook-form";
import { useLocation, useParams } from "react-router-dom";
import { callApi, getMonitoringPlanFlags } from "../../../../services/MonitoringPlanService";
import { API_ROUTES } from "../FeuApiRoutes/FeuApiRoutes";
import { emitToasterMsg } from "../../../../services/toasterUtility";
const CreationDatePicker = ({ control, errors, createdDate, setCreatedDate }) => (
  <Controller
    name="createdDate"
    control={control}
    rules={{ required: "Field is required" }}
    defaultValue={createdDate}
    render={({ field }) => (
      <>
        <DatePicker
          {...field}
          value={createdDate}
          onChange={(val) => {
            setCreatedDate(val);
            field.onChange(val);
          }}
          format="DD-MM-YYYY"
          slotProps={{
            actionBar: { actions: ["today"] },
            textField: {
              sx: {
                width: 400,
                "& .MuiInputBase-root": { height: 36 },
                "& input": {
                  padding: "8px 10px",
                  fontSize: "14px",
                },
              },
            },
          }}
        />
        {errors?.createdDate && (
          <div className="error-msg">{errors?.createdDate.message}</div>
        )}
      </>
    )}
  />
);
const MpParticulars = ({ refetchMonitoringData, mpParticularsData,vesselMstId }) => {
  const {
    control,
    formState: { errors },
  } = useForm();
 
  const [createdDate, setCreatedDate] = useState(() => {
    if (mpParticularsData?.createdDate) {
      return dayjs(mpParticularsData.createdDate);
    }
    return dayjs();
  });
 
  useEffect(() => {
    if (mpParticularsData?.createdDate) {
      setCreatedDate(dayjs(mpParticularsData.createdDate));
    }
  }, [mpParticularsData]);
 
  const handleSubmit = async () => {
    const payload = {
      vesselMstId: vesselMstId ? Number(vesselMstId) : null,
      createdDate: createdDate?.toISOString(),
      status: "Created",
      version: 0,
      isActive: true,
    };
 
    try {
      const response = await callApi({
        method: "POST",
        url: API_ROUTES.A,
        data: payload,
      });
 
      if (response?.isSuccess) {
        await getMonitoringPlanFlags(vesselMstId);
        emitToasterMsg("success","","Creation date has been updated successfully");
        if (typeof refetchMonitoringData === "function") {
          await refetchMonitoringData();
        }
      } else {
        emitToasterMsg("error", "", response?.errorMessage || "Save failed");
      }
    } catch (err) {
      console.error("API Error:", err);
      const errorMsg = err?.response?.data?.errorMessage || err?.response?.data?.message || err?.message || "An unexpected error occurred";
      emitToasterMsg("error", "", err.errorMsg);
    }
  };
 
  return (
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      <div className="mp-container mt-4">
          <MDBRow>
            <MDBCol md="1">
              <Label name="Creation Date" bold required className="mt-2" />
            </MDBCol>
            <MDBCol md="3">
              <CreationDatePicker control={control} errors={errors} createdDate={createdDate} setCreatedDate={setCreatedDate} />
            </MDBCol>
            <MDBCol md="1">
              <div>
                <Button onClick={handleSubmit}>Save</Button>
              </div>
            </MDBCol>
          </MDBRow>
       
      </div>
    </LocalizationProvider>
  );
};
 
export default MpParticulars;